<template>
<div class="right_body action_body">
   
   <span class="btn right_sub_btn add_btn" style="margin-right:200px" @click.stop="onSubmitBatchFeature">提交数据</span>
   <!-- <span class="btn right_sub_btn save_btn" style="margin-right:200px" @click.stop="onImitateBatchPrice">模拟价格</span> -->
   <span class="btn right_sub_btn save_btn" style="margin-right:100px" @click.stop="onConvertSalePrice">转销售价</span>
   <span class="btn right_sub_btn add_btn" @click.stop="onBackBatchFeatureSpage">返回查询</span>
   
   <div class="active_rumb">
      <span class="txt">维护芳疗批次特性</span>
   </div>

   <SaleBatchFeatureTForm ref='batchFeatureTForm' :formData="formData"></SaleBatchFeatureTForm>

   <SaleBatchFeatureCTable ref="batchFeatureCTable" :batchFeatureFormData="formData" :batchFeatureDataSet="batchFeatureRowSet"></SaleBatchFeatureCTable>
</div>
</template>

<script>
import SaleBatchFeatureTForm from "./components/salebatchfeature/SaleBatchFeatureTForm.vue";
import SaleBatchFeatureCTable from "./components/salebatchfeature/SaleBatchFeatureCTable.vue";
import {batchCharact } from "api/business.js";
import { mapState,mapActions } from 'vuex';  

export default {
    components:{
        SaleBatchFeatureTForm,SaleBatchFeatureCTable
    },
    props:{
      mateiralProp:{
          type:Object,
          default(){
                  return {}
          }
      }
    },
    created(){
        this.batchFeatureMaterial=this.$store.state.cache.batchFeatureMateiral;
        this.formData.materialId=this.batchFeatureMaterial.materialId;
        this.formData.materialCode=this.batchFeatureMaterial.materialCode;
        this.formData.materialDesc=this.batchFeatureMaterial.materialDesc;
        this.$store.state.cache.batchFeatureMateiral=null;

        this.loadMaterialBatchFeature(this.formData.materialId);
    },
    updated(){

    },
    /**
     * 组件被激活
     */
    activated(){
        // this.batchFeatureMaterial=this.$store.state.cache.batchFeatureMateiral;
        // this.formData.materialId=this.batchFeatureMaterial.materialId;
        // this.formData.materialCode=this.batchFeatureMaterial.materialCode;
        // this.formData.materialDesc=this.batchFeatureMaterial.materialDesc;
        // this.$store.state.cache.batchFeatureMateiral=null;

        // this.loadMaterialBatchFeature(this.formData.materialId);
    },
    data(){
        return {
            formData:{},
            batchFeatureRowSet:[]
        }
    },
    methods:{
         ...mapActions('pages',[
            "open",
            "init",
            "close",
            "closeOther",
            "closeAll"
        ]),
        /**
         * 触发提交批次数据
         */
        onSubmitBatchFeature(){
           
           this.formData=this.$refs.batchFeatureTForm.saleBatchHeader;
           this.formData.batchFeatureList=this.$refs.batchFeatureCTable.batchFeaturesRowSet;

           this.submitBatchFeature(this.formData);
        },
        /**
         *模拟批次价格
         */
        onImitateBatchPrice(){
           alert("模拟批次价格");
        },
        /**
         * 触发批次特性转销售价
         */
        onConvertSalePrice(){           
            this.$alert('确定将批次特性转销售价', '转销售价', {
                confirmButtonText: '确定',
                callback: action => { 
                    debugger;               
                    this.formData=this.$refs.batchFeatureTForm.saleBatchHeader;
                    this.formData.batchFeatureList=this.$refs.batchFeatureCTable.batchFeaturesRowSet;                    
                    this.submitBatchCvtSalePrice(this.formData);
                }
            });           
        },
        /**
         * 返回到批次查询页
         */
        onBackBatchFeatureSpage(){
            let vm=this;
            vm.close({ tagName: "business-sale-batchHelp" });
            vm.$router.push({ name: "business-sale-batchCharact" });
        },
        /**
         * 提交批次特性
         */
        async submitBatchFeature(materialBatchFeature){
           let res = await this.$post(batchCharact.add, materialBatchFeature);  

           if (!res.status){
              this.$message.error(res.errorMsg);
              return false;
           } 
           let vm=this;
           this.$alert('批次特性维护成功！', '提示', {
                confirmButtonText: '完成',
                center: true,
                callback: action => {    
                    this.onBackBatchFeatureSpage();       
                    vm.$router.push({ name: "business-sale-batchCharact" });
                }
            });
        },
        /**
         * 加载物料批次特性
         */
        async loadMaterialBatchFeature(materialId){
           let res = await this.$get(batchCharact.list, {
               materialId:materialId
           }); 
           debugger;          
           if (!res.status){
              this.$message.error(res.errorMsg);
              return false;
           } 
           if(!res.data){
               return false;
           }
           this.formData=res.data;
           this.batchFeatureRowSet=res.batchFeatureList;

           this.$refs.batchFeatureTForm.saleBatchHeader=res.data;
           this.$refs.batchFeatureCTable.batchFeaturesRowSet=res.data.batchFeatureList;
        },
        /**
         * 批次特性转为销售价
         */
        async submitBatchCvtSalePrice(materialBatchFeature){
           let res = await this.$post(batchCharact.batchCvtPriceUrl, materialBatchFeature);  

           if (!res.status){
              this.$message.error(res.errorMsg);
              return false;
           } 
           let vm=this;
           this.$alert('批次特性转销售价成功！', '提示', {
                confirmButtonText: '完成',
                center: true,
                callback: action => {                
                    vm.$router.push({ name: "business-sale-batchCharact" });
                }
            });
        }
    }
}
</script>